<template>
    <div
      aria-live="assertive"
      class="
        fixed
        inset-0
        flex
        items-end
        px-4
        py-6
        pointer-events-none
        sm:p-6 sm:items-start
      "
    >
      <div class="w-full flex flex-col items-center space-y-4 sm:items-end mt-12">
        <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
        <transition
          v-for="(success_notification, index_success_notification) in successNotifications" :key="index_success_notification"
          enter-active-class="transform ease-out duration-300 transition"
          enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition ease-in duration-300"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            class="
              max-w-sm
              w-full
              bg-white
              shadow-lg
              rounded-lg
              pointer-events-auto
              ring-1 ring-black ring-opacity-5
              overflow-hidden
            "
          >
            <div class="p-4">
              <div class="flex items-start">
                <div class="flex-shrink-0">
                  <i
                    class="fa-solid fa-circle-check h-6 w-6 text-green-600"
                  ></i>
                </div>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  <p class="text-sm font-medium text-gray-900">
                    {{ success_notification.title }}
                  </p>
                  <p class="mt-1 text-sm text-gray-500">
                    {{ success_notification.message }}
                  </p>
                  <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                    <div class="bg-green-600 h-2.5 rounded-full" :style="`width: ${success_notification.timer/(getSuccessNotificationTime()/100)}%`"></div>
                  </div>
                </div>
                
                <div class="ml-4 flex-shrink-0 flex">
                  <button
                    type="button"
                    @click="removeSuccessNotification(success_notification.id)"
                    class="
                      bg-white
                      rounded-md
                      inline-flex
                      text-gray-400
                      hover:text-gray-500
                      focus:outline-none
                      focus:ring-2
                      focus:ring-offset-2
                      focus:ring-lime-500
                    "
                  >
                    <span class="sr-only">Close</span>
                    <i class="fa-solid fa-xmark h-5 w-5"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
        
      </div>
    </div>
</template>

<script>
export default {
  name: "AppNotifications",
  
  data() {
    return {
    }
  },
  methods: {
    removeSuccessNotification: function(success_notification_id){
      this.$store.commit("notifications/removeSuccessNotification", success_notification_id);
    },
    getSuccessNotificationTime: function(){
      return this.$store.getters["notifications/getSuccessNotificationTime"];
    },
  },
  computed: {
    successNotifications() {
      return this.$store.getters["notifications/getSuccessNotifications"];
    },
  },
}
</script>


